import { AppContext } from './AppContext';
import { useContext } from 'react';

export const useHomeInfo = () => {
  const context = useContext(AppContext);
  return context.homeInfo;
};
